import React from 'react';
import ClaimStorePicker from '../onboarding/ClaimStorePicker';

export default function ClaimStorePage() {
  return (
    <div className="p-4 sm:p-6" data-testid="vendor-claim-store-page">
      <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">Claim a store</h1>
      <p className="text-sm text-slate-500 mt-1 mb-5">
        Add a ready-made AI store to your account. It becomes your own independent store
        (pending super-admin approval) and shows up in your store switcher.
      </p>
      <ClaimStorePicker />
    </div>
  );
}
